import svgUrl from "ni:svgr;_2U_OUAqgzprVa0XvhEIJHfcn_zQGgrghXuCPHjYff8";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const CollapseIcon = props => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="currentColor" d="M4 8h8" /></svg>;
const Memo = memo(CollapseIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "CollapseIcon";
}